/* =========================================================
   AllDoneHub Pro Space — theme.js
   Cart + drawer, announcement marquee, header, reveal
   animations, quantity steppers, sticky mobile buy bar,
   variant picker, free-shipping meter.
   No dependencies. Works with the Shopify Ajax Cart API.
   ========================================================= */
(function () {
  'use strict';

  var CFG = window.ADH || {};
  var SET = window.ADHSettings || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------
     Money helper — ADH.moneyFormat comes from Liquid.
     Shopify formats use {{amount}} / {{amount_no_decimals}}.
     --------------------------------------------------------- */
  var currencySymbol = '₹';
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var value = cents / 100;
    var decimals = /\.\d\d/.test(String(value)) || cents % 100 !== 0 ? 2 : 0;
    var fmt = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: 2
    }).format(value);
    var template = CFG.moneyFormat || '<span class=money>' + currencySymbol + '{{amount}}</span>';
    var out = template
      .replace(/\{\{\s*amount\s*\}\}/g, fmt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(value)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fmt)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(value)));
    return out.replace(/<span class=money>|<\/span>/g, '');
  }

  /* ---------------- toast ---------------- */
  var toastEl = $('#AdhToast');
  var toastTimer;
  function toast(message, icon) {
    if (!toastEl) return;
    toastEl.innerHTML = (icon || '') + '<span>' + message + '</span>';
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3200);
  }
  window.ADHToast = toast;

  /* ---------------- header polish ---------------- */
  var header = $('.adh-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var burger = $('[data-menu-toggle]');
  var mobileMenu = $('#AdhMobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var searchToggle = $('[data-search-toggle]');
  var searchPanel = $('#AdhSearchPanel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hidden ? true : false;
      searchPanel.hidden = !open;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input', searchPanel); if (i) i.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (searchPanel.hidden) return;
      if (searchPanel.contains(e.target) || searchToggle.contains(e.target)) return;
      searchPanel.hidden = true;
    });
  }

  /* ---------------- quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    if (!wrap) return;
    var input = $('input', wrap);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '99', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    next = Math.max(min, Math.min(max, next));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- reveal on scroll ---------------- */
  var revealEls = $$('.adh-reveal');
  if (revealEls.length) {
    if (!SET.reveal || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    }
  }

  /* ---------------------------------------------------------
     Cart drawer
     --------------------------------------------------------- */
  var drawer = $('#AdhCartDrawer');
  var overlay = $('#AdhOverlay');
  var sectionsToRender = [{ id: 'cart-drawer' }];

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = $('[data-drawer-close]', drawer);
    if (close) close.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.ADHCartOpen = openDrawer;

  /* delegated so the handlers survive section re-renders */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); openDrawer(); return; }
    var closer = e.target.closest('[data-drawer-close], [data-drawer-dismiss]');
    if (closer) { e.preventDefault(); closeDrawer(); return; }
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
  window.ADHCartClose = closeDrawer;

  function refreshSections(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    sectionsToRender.forEach(function (section) {
      var fresh = doc.querySelector('[data-section-type="' + section.id + '"]') || doc.getElementById('shopify-section-' + section.id);
      var current = document.querySelector('[data-section-type="' + section.id + '"]') || document.getElementById('shopify-section-' + section.id);
      if (fresh && current) {
        var freshInner = fresh.querySelector('.adh-drawer__body') ? fresh : fresh.firstElementChild || fresh;
        current.innerHTML = freshInner.innerHTML;
      }
    });
    hydrateCartCount(doc);
    bindDrawerControls();
  }

  function hydrateCartCount(doc) {
    var src = (doc || document).querySelector('[data-cart-count-source]');
    if (!src) return;
    var count = src.getAttribute('data-cart-count-source');
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === '0';
    });
  }

  /* delegated cart-line controls (drawer content is re-rendered after every change) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-change]');
    if (!input) return;
    updateLine(input.getAttribute('data-line-change'), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    updateLine(btn.getAttribute('data-line-remove'), 0);
  });

  function bindDrawerControls() {
    updateShipBar();
  }

  function updateShipBar() {
    var bar = $('[data-shipbar-fill]');
    if (!bar) return;
    var subtotal = parseInt(bar.getAttribute('data-subtotal') || '0', 10);
    var threshold = parseFloat(CFG.freeShipping || SET.freeShipping || 499) * 100;
    if (!threshold) { bar.style.width = '100%'; return; }
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    bar.style.width = pct + '%';
    var label = $('[data-shipbar-label]');
    if (label) {
      if (subtotal >= threshold) {
        label.innerHTML = '<strong>' + (SET.msgFreeShipUnlocked || 'Free shipping unlocked') + '</strong>';
      } else {
        var left = formatMoney(threshold - subtotal);
        label.innerHTML = (SET.msgFreeShipUnlock || 'You are {amount} away from free shipping').replace('{amount}', '<strong>' + left + '</strong>');
      }
    }
  }

  function request(url, options) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, options))
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      });
  }

  function renderCart() {
    return fetch(CFG.cartUrl + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(refreshSections);
  }

  function addToCart(variantId, quantity) {
    return request(CFG.cartAddUrl + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) || 1 }] })
    }).then(function () {
      return renderCart();
    }).then(function () {
      toast(SET.msgAdded || 'Added to cart', '<svg class="adh-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="m5 13 4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      if (CFG.drawerEnabled) openDrawer();
      updateShipBar();
    }).catch(function (err) {
      toast((err && err.description) || SET.msgError || 'Sorry, that item could not be added.', '');
    });
  }

  function updateLine(line, quantity) {
    return request(CFG.cartChangeUrl + '.js', {
      method: 'POST',
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(renderCart).catch(function () {
      toast(SET.msgError || 'Cart could not be updated.');
    });
  }

  /* ajax add-to-cart forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[name="quantity"]', form);
    if (!idInput) return;
    var btn = $('[data-add-button]', form);
    if (btn) { btn.classList.add('is-disabled'); btn.setAttribute('aria-busy', 'true'); }
    addToCart(idInput.value, qtyInput ? qtyInput.value : 1).finally(function () {
      if (btn) { btn.classList.remove('is-disabled'); btn.removeAttribute('aria-busy'); }
    });
  });

  bindDrawerControls();
  hydrateCartCount();

  /* cart note + shipping remark in drawer */
  var noteField = $('[data-cart-note]');
  if (noteField) {
    noteField.addEventListener('change', function () {
      request(CFG.cartUpdateUrl + '.js', {
        method: 'POST',
        body: JSON.stringify({ note: noteField.value })
      }).catch(function () {});
    });
  }

  /* ---------------------------------------------------------
     Variant picker (product page)
     --------------------------------------------------------- */
  var productForm = $('form[data-product-form]');
  if (productForm) {
    var variants = [];
    try { variants = JSON.parse($('[data-variant-json]').textContent); } catch (err) { variants = []; }

    function currentOptions() {
      return $$('[data-option-index]', productForm).map(function (group) {
        var active = $('.adh-pill.is-active', group);
        return active ? active.getAttribute('data-value') : null;
      });
    }
    function findVariant() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function paintVariant(variant) {
      if (!variant) return;
      var idInput = $('[name="id"]', productForm);
      if (idInput) idInput.value = variant.id;
      $$('[data-sticky-variant]').forEach(function (el) { el.value = variant.id; });

      var priceWrap = $('[data-price-wrap]');
      if (priceWrap) {
        var now = $('[data-price-now]', priceWrap);
        var was = $('[data-price-was]', priceWrap);
        var save = $('[data-price-save]', priceWrap);
        if (now) now.textContent = formatMoney(variant.price);
        if (was) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            was.textContent = formatMoney(variant.compare_at_price);
            was.hidden = false;
          } else { was.hidden = true; }
        }
        if (save) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            save.textContent = (SET.msgSave || 'Save') + ' ' + formatMoney(variant.compare_at_price - variant.price);
            save.hidden = false;
          } else { save.hidden = true; }
        }
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      }

      var addBtn = $('[data-add-button]', productForm);
      var stickyBtn = $('[data-sticky-button]');
      var available = variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        var span = $('[data-add-label]', addBtn);
        if (span) span.textContent = available ? (SET.msgAdd || 'Add to cart') : (SET.msgSoldOut || 'Sold out');
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        var stx = $('[data-add-label]', stickyBtn);
        if (stx) stx.textContent = available ? (SET.msgAdd || 'Add to cart') : (SET.msgSoldOut || 'Sold out');
      }

      var media = $('[data-gallery-main] img');
      if (media && variant.featured_image && variant.featured_image.src) {
        media.src = variant.featured_image.src;
        media.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    productForm.addEventListener('click', function (e) {
      var pill = e.target.closest('.adh-pill[data-value]');
      if (!pill) return;
      e.preventDefault();
      var group = pill.closest('[data-option-index]');
      $$('.adh-pill', group).forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      paintVariant(findVariant());
    });

    if (variants.length) paintVariant(findVariant() || variants[0]);
  }

  /* thumbnail gallery */
  $$('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = $('[data-gallery-main] img');
      if (!main) return;
      var img = $('img', thumb);
      if (!img) return;
      main.src = img.getAttribute('data-full') || img.src;
      $$('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------------------------------------------------------
     Sticky mobile buy bar
     --------------------------------------------------------- */
  var sticky = $('[data-sticky-bar]');
  if (sticky) {
    document.body.classList.add('has-sticky');
    var anchor = $('[data-sticky-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      obs.observe(anchor);
    } else {
      sticky.classList.add('is-show');
    }
  }

  /* ---------------------------------------------------------
     Bundle tiers — update quantity + summary + CTA label
     --------------------------------------------------------- */
  $$('[data-bundle]').forEach(function (root) {
    var tiers = $$('.adh-tier', root);
    var form = $('form', root);
    var qtyInput = $('[data-bundle-qty]', root);
    var label = $('[data-bundle-cta-label]', root);
    var total = $('[data-bundle-total]', root);
    var saved = $('[data-bundle-saved]', root);
    var dispatch = $('[data-bundle-dispatch]', root);

    function select(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
      var radio = $('input[type="radio"]', tier);
      if (radio) radio.checked = true;
      var qty = tier.getAttribute('data-qty') || '1';
      if (qtyInput) qtyInput.value = qty;
      if (label) label.textContent = tier.getAttribute('data-cta') || label.textContent;
      var totalMoney = tier.getAttribute('data-total-money') || '';
      if (total) total.innerHTML = totalMoney;
      $$('[data-bundle-total-money]', root).forEach(function (el) { el.innerHTML = totalMoney; });
      if (saved) {
        var s = tier.getAttribute('data-save-money');
        saved.innerHTML = s ? (SET.msgYouSave || 'You save') + ' ' + s : '';
        saved.hidden = !s;
      }
      if (dispatch) dispatch.textContent = (qty > 1 ? (qty + ' units · ') : '') + (dispatch.getAttribute('data-base') || '');
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        e.preventDefault();
        select(tier);
      });
      var radio = $('input[type="radio"]', tier);
      if (radio) {
        radio.addEventListener('change', function () { select(tier); });
      }
    });

    if (tiers.length) {
      var preset = tiers.find(function (t) { return t.classList.contains('is-selected'); }) || tiers[0];
      select(preset);
    }

    /* bundle form posts total quantity of the chosen variant */
    if (form) {
      var baseId = $('[data-bundle-variant]', form);
      var realId = $('[name="id"]', form);
      if (baseId && realId) realId.value = baseId.value;
    }
  });

  /* ---------------------------------------------------------
     Collection / search: submit on filter change
     --------------------------------------------------------- */
  $$('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var form = el.closest('form');
      if (form) form.submit();
    });
  });

  window.ADHMoney = formatMoney;
})();
